/* ==========================================================================
   BATHIMO™ — theme.js
   JavaScript ligero, sin dependencias. No intercepta el scroll de la página.
   - Menú móvil
   - Galería de producto (miniaturas + deslizamiento táctil)
   - Variantes: precio, precio anterior, disponibilidad, imagen y URL
   - Añadir al carrito vía AJAX (con envío normal como alternativa sin JS)
   - Carrito: actualizar cantidades y eliminar productos sin recargar
   - Vídeo bajo demanda y animaciones de aparición
   ========================================================================== */
(function () {
  'use strict';

  var B = window.BATHIMO || { routes: {}, strings: {} };

  /* ---------- Utilidades ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || B.moneyFormat || '{{amount_with_comma_separator}} €';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      default: value = formatWithDelimiters(cents, 2, '.', ',');
    }
    return formatString.replace(placeholderRegex, value);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  /* ---------- Menú móvil (se despliega en el flujo, sin bloquear el scroll) ---------- */
  function initMobileMenu(scope) {
    var toggle = (scope || document).querySelector('[data-mobile-toggle]');
    var panel = (scope || document).querySelector('[data-mobile-panel]');
    if (!toggle || !panel || toggle.dataset.bound) return;
    toggle.dataset.bound = 'true';

    function close() {
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { close(); toggle.focus(); }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) { if (mq.matches) close(); });
  }

  /* ---------- Galería ---------- */
  function Gallery(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-gallery-viewport]');
    this.items = Array.prototype.slice.call(root.querySelectorAll('.gallery__item'));
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('.gallery__dot'));
    this.index = 0;
    if (!this.viewport || this.items.length === 0) return;

    var self = this;
    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { self.goTo(Number(thumb.dataset.index)); });
    });
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });

    // Sincroniza el índice cuando el usuario desliza con el dedo (scroll horizontal nativo)
    var ticking = false;
    this.viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(self.viewport.scrollLeft / self.viewport.clientWidth);
        self.setActive(i);
        ticking = false;
      });
    }, { passive: true });

    this.viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
    });
  }
  Gallery.prototype.goTo = function (i, instant) {
    var count = this.items.length;
    i = (i + count) % count;
    // scrollTo solo en horizontal dentro del carrusel: la página no se mueve
    this.viewport.scrollTo({ left: i * this.viewport.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    this.setActive(i);
    this.pauseVideos();
  };
  Gallery.prototype.goToMedia = function (mediaId) {
    for (var i = 0; i < this.items.length; i++) {
      if (String(this.items[i].dataset.mediaId) === String(mediaId)) { this.goTo(i); return; }
    }
  };
  Gallery.prototype.setActive = function (i) {
    if (i === this.index && this.thumbs.length && this.thumbs[i] && this.thumbs[i].classList.contains('is-active')) return;
    this.index = i;
    this.thumbs.forEach(function (t, n) {
      t.classList.toggle('is-active', n === i);
      if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    this.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    var active = this.thumbs[i];
    if (active && active.parentElement && active.parentElement.parentElement) {
      var strip = active.parentElement.parentElement;
      var left = active.offsetLeft - strip.clientWidth / 2 + active.clientWidth / 2;
      strip.scrollTo({ left: left, behavior: 'smooth' });
    }
  };
  Gallery.prototype.pauseVideos = function () {
    this.root.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
  };

  /* ---------- Producto: variantes + añadir al carrito ---------- */
  function ProductController(root) {
    this.root = root;
    var json = root.querySelector('[data-product-json]');
    this.variants = json ? JSON.parse(json.textContent) : [];
    this.form = root.querySelector('[data-product-form]');
    this.idInput = root.querySelector('[data-variant-input]');
    this.addButton = root.querySelector('[data-add-button]');
    this.addLabel = root.querySelector('[data-add-label]');
    this.status = root.querySelector('[data-form-status]');
    this.optionInputs = Array.prototype.slice.call(root.querySelectorAll('.option__input'));
    var galleryEl = root.querySelector('[data-gallery]');
    this.gallery = galleryEl ? new Gallery(galleryEl) : null;
    this.isProductPage = !!root.closest('.section-main-product, #producto');

    var self = this;
    this.optionInputs.forEach(function (input) {
      input.addEventListener('change', function () { self.onOptionChange(); });
    });
    if (this.form) this.form.addEventListener('submit', function (e) { self.onSubmit(e); });

    // Muestra la imagen de la variante inicial si no es la primera
    var current = this.currentVariant();
    if (current && current.featured_media && this.gallery) {
      var g = this.gallery;
      var idx = g.items.findIndex(function (it) { return String(it.dataset.mediaId) === String(current.featured_media.id); });
      if (idx > 0) {
        window.requestAnimationFrame(function () { g.goTo(idx, true); });
      }
    }
  }
  ProductController.prototype.currentVariant = function () {
    var id = this.idInput ? Number(this.idInput.value) : null;
    return this.variants.find(function (v) { return v.id === id; }) || this.variants[0];
  };
  ProductController.prototype.selectedOptions = function () {
    var selected = [];
    this.optionInputs.forEach(function (input) {
      if (input.checked) selected[Number(input.dataset.optionIndex)] = input.value;
    });
    return selected;
  };
  ProductController.prototype.onOptionChange = function () {
    var selected = this.selectedOptions();
    var root = this.root;
    selected.forEach(function (value, i) {
      var label = root.querySelector('[data-option-label="' + i + '"]');
      if (label) label.textContent = value;
    });
    var variant = this.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
    this.updateAvailabilityMarks(selected);
    this.render(variant);
  };
  // Tacha los valores que no forman una combinación disponible con el resto de la selección
  ProductController.prototype.updateAvailabilityMarks = function (selected) {
    var variants = this.variants;
    this.optionInputs.forEach(function (input) {
      var idx = Number(input.dataset.optionIndex);
      var test = selected.slice();
      test[idx] = input.value;
      var available = variants.some(function (v) {
        return v.available && v.options.every(function (opt, i) { return test[i] === undefined || opt === test[i]; });
      });
      var label = input.nextElementSibling;
      if (label) label.classList.toggle('is-unavailable', !available);
    });
  };
  ProductController.prototype.render = function (variant) {
    var s = B.strings;
    var priceWrap = this.root.querySelector('[data-price]');
    var current = this.root.querySelector('[data-price-current]');
    var compare = this.root.querySelector('[data-price-compare]');
    var availability = this.root.querySelector('[data-availability]');
    var availabilityText = this.root.querySelector('[data-availability-text]');
    this.hideStatus();

    if (!variant) {
      if (this.addButton) this.addButton.disabled = true;
      if (this.addLabel) this.addLabel.textContent = s.unavailable;
      if (availability) availability.classList.add('is-out');
      if (availabilityText) availabilityText.textContent = s.unavailable;
      return;
    }

    if (this.idInput) {
      this.idInput.value = variant.id;
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (current) current.textContent = formatMoney(variant.price);
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compare) {
      compare.hidden = !onSale;
      compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
    }
    if (priceWrap) priceWrap.classList.toggle('price--on-sale', !!onSale);

    if (this.addButton) this.addButton.disabled = !variant.available;
    if (this.addLabel) this.addLabel.textContent = variant.available ? s.addToCart : s.soldOut;
    if (availability) availability.classList.toggle('is-out', !variant.available);
    if (availabilityText) availabilityText.textContent = variant.available ? s.inStock : s.outOfStock;

    if (variant.featured_media && this.gallery) this.gallery.goToMedia(variant.featured_media.id);

    // Actualiza la URL en la ficha de producto (sin recargar ni mover la página)
    if (this.isProductPage && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };
  ProductController.prototype.hideStatus = function () {
    if (!this.status) return;
    this.status.hidden = true;
    this.status.classList.remove('is-error');
    this.status.innerHTML = '';
  };
  ProductController.prototype.showStatus = function (html, isError) {
    if (!this.status) return;
    this.status.innerHTML = html;
    this.status.classList.toggle('is-error', !!isError);
    this.status.hidden = false;
  };
  ProductController.prototype.onSubmit = function (e) {
    if (!window.fetch || !window.FormData) return; // envío clásico a /cart/add
    e.preventDefault();
    var self = this;
    var btn = this.addButton;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    this.hideStatus();

    var addUrl = (B.routes.cart_add || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(this.form)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) {
          self.showStatus('<span>' + (r.data.description || r.data.message || B.strings.error) + '</span>', true);
          return;
        }
        self.showStatus(
          '<span>✓ ' + B.strings.added + '</span><a href="' + (B.routes.cart || '/cart') + '">' + B.strings.viewCart + ' →</a>'
        );
        return fetch((B.routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            document.dispatchEvent(new CustomEvent('bathimo:cart-updated', { detail: cart }));
          });
      })
      .catch(function () { self.showStatus('<span>' + B.strings.error + '</span>', true); })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
      });
  };

  /* ---------- Selectores de cantidad ---------- */
  function initQuantity(scope) {
    (scope || document).querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = 'true';
      var input = wrap.querySelector('input');
      var min = Number(input.min || 0);
      wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
        input.value = Math.max(min, Number(input.value || 0) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
        input.value = Number(input.value || 0) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Carrito (Section Rendering API de Shopify) ---------- */
  function initCart(scope) {
    var section = (scope || document).querySelector('[data-cart-section]');
    if (!section || section.dataset.bound) return;
    section.dataset.bound = 'true';
    var sectionId = section.dataset.sectionId;
    var timer;

    function change(line, quantity) {
      var wrapper = section.querySelector('.cart');
      if (wrapper) wrapper.classList.add('is-updating');
      fetch((B.routes.cart_change || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: [sectionId], sections_url: window.location.pathname })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (cart.status && cart.status >= 400) throw new Error(cart.description || cart.message);
          updateCartCount(cart.item_count);
          var html = cart.sections && cart.sections[sectionId];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-cart-section]');
            if (fresh) {
              section.innerHTML = fresh.innerHTML;
              section.dataset.bound = '';
              initCart(section.parentElement);
              initQuantity(section);
              var status = section.querySelector('[data-cart-status]');
              if (status) status.textContent = B.strings.cartUpdated || '';
            }
          } else {
            window.location.reload();
          }
        })
        .catch(function (err) {
          if (wrapper) wrapper.classList.remove('is-updating');
          window.alert((err && err.message) || B.strings.error);
          window.location.reload();
        });
    }

    section.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      clearTimeout(timer);
      timer = setTimeout(function () { change(input.dataset.line, input.value); }, 350);
    });
    section.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (!remove || !window.fetch) return;
      e.preventDefault();
      change(remove.dataset.line, 0);
    });
    var note = section.querySelector('[data-cart-note]');
    if (note) {
      note.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });
    }
  }

  /* ---------- Vídeo bajo demanda ---------- */
  function initVideos(scope) {
    (scope || document).querySelectorAll('[data-video]').forEach(function (frame) {
      var play = frame.querySelector('[data-video-play]');
      if (!play || play.dataset.bound) return;
      play.dataset.bound = 'true';
      play.addEventListener('click', function () {
        var video = frame.querySelector('video');
        var tpl = frame.querySelector('template[data-video-embed]');
        if (tpl) {
          frame.appendChild(tpl.content.cloneNode(true));
        } else if (video) {
          video.play().catch(function () {});
        }
        frame.classList.add('is-playing');
        var focusTarget = frame.querySelector('video, iframe');
        if (focusTarget) focusTarget.focus && focusTarget.focus();
      });
    });
  }

  /* ---------- Selectores de país / idioma ---------- */
  function initAutosubmit(scope) {
    (scope || document).querySelectorAll('[data-autosubmit]').forEach(function (select) {
      select.addEventListener('change', function () { select.form.submit(); });
    });
  }

  /* ---------- Animaciones de aparición (no afectan al scroll) ---------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.reveal:not(.is-visible)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Inicialización ---------- */
  function initProducts(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';
      new ProductController(root);
    });
  }

  function init(scope) {
    initMobileMenu(scope);
    initQuantity(scope);
    initProducts(scope);
    initCart(scope);
    initVideos(scope);
    initAutosubmit(scope);
    initReveal(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Editor de temas de Shopify: reinicia la sección editada
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
